import { jsx as _jsx } from "react/jsx-runtime";
import { Testids } from '@mono/ui-selectors';
import { Link } from 'react-router-dom';
import { canonicalAppHref, isExternalHref, matchAppRoute } from '../../../lib/applinks/appLinks';
import { useChatLinks } from '../../ChatView/ChatLinksContext';
/**
 * A link in rendered markdown.
 *
 * - Outside a chat thread: external links open in a new tab, as before.
 * - In a chat thread (J5): a path into the app is a same-tab router link only
 *   when it opens a catalogued page AND a tool returned that exact href to
 *   this user in this chat; any other app path is plain text. External links
 *   still open in a new tab. A javascript:, data: or other scheme is never a
 *   link anywhere.
 */ export function LinkWithPreview({ href, children, className }) {
    const chat = useChatLinks();
    const raw = href ?? '';
    if (raw && isExternalHref(raw)) {
        return /*#__PURE__*/ _jsx("a", {
            href: raw,
            className: className,
            target: "_blank",
            rel: "noopener noreferrer",
            children: children
        });
    }
    const canon = raw ? canonicalAppHref(raw) : null;
    if (chat && canon && matchAppRoute(canon) && chat.hrefs.has(canon)) {
        const openInApp = chat.openInApp;
        return /*#__PURE__*/ _jsx(Link, {
            to: canon,
            className: className,
            "data-testid": Testids.assistant.appLink,
            onClick: (e)=>{
                // A plain click keeps the chat beside the page; modified clicks
                // (new tab, new window) behave like any link.
                if (!openInApp || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) {
                    return;
                }
                e.preventDefault();
                openInApp(canon);
            },
            children: children
        });
    }
    if (chat || raw && !canon) {
        return /*#__PURE__*/ _jsx("span", {
            "data-testid": Testids.assistant.appLinkText,
            children: children
        });
    }
    // Outside chat, an in-app path keeps the old behaviour.
    return /*#__PURE__*/ _jsx("a", {
        href: raw || undefined,
        className: className,
        target: "_blank",
        rel: "noopener noreferrer",
        children: children
    });
}
export default LinkWithPreview;
